<div *ngIf="inhaberId !== undefined" class="icon-link-wrapper">
  <jf-link
    *ngFor="let navigationLink of navigationLinks"
    [variant]="'navigation'"
    [routerLink]="[navigationLink.route, 'inhaber', inhaberId]"
    [text]="navigationLink.label"
    [iconName]="navigationLink.iconName"
    iconPosition="before"
    routerLinkActive="active"
    i18n-text
  ></jf-link>

  <div class="action-button-wrapper">
    <ng-container *ngFor="let button of buttonViewModels$ | async; trackBy: trackByButtonId">
      <jf-split-button
        *ngIf="button.isSplit; else simpleButton"
        [text]="button.label"
        [icon]="button.icon"
        [variant]="button.splitVariant"
        [disabled]="button.disabled"
        [menuItems]="button.menuItems"
        toggleAriaLabel="Weitere Belegarten"
        (doClick)="doButtonAction(button.source)"
      ></jf-split-button>

      <ng-template #simpleButton>
        <jf-button
          [variant]="button.variant"
          [icon]="button.icon"
          [text]="button.label"
          [iconPosition]="button.iconPosition"
          (click)="doButtonAction(button.source)"
          [disabled]="button.disabled"
        ></jf-button>
      </ng-template>
    </ng-container>
  </div>
</div>

<div class="content-wrapper">
  <router-outlet></router-outlet>
</div>
